import { render, staticRenderFns } from "./TabelaReuFederal.vue?vue&type=template&id=aa27761e&scoped=true&"
import script from "./TabelaReuFederal.vue?vue&type=script&lang=js&"
export * from "./TabelaReuFederal.vue?vue&type=script&lang=js&"
import style0 from "./TabelaReuFederal.vue?vue&type=style&index=0&id=aa27761e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa27761e",
  null
  
)

export default component.exports